import 'css/src/components/common/ui/Avatar';

import type { ForwardedRef } from 'react';
import React from 'react';
import classnames from 'classnames';

type Props = {
    image?: string | null;
    imageCustomClass?: string;
    textCustomClass?: string;
    text?: string;
    size?: 'xlarge' | 'large' | 'normal' | 'small';
    topLeftBadge?: React.ReactNode;
    onClick?: VoidFunction;
    className?: string;
    shouldHighlight?: boolean;
};

/**
 * Shows user's profile image.
 */
function AvatarFunc(
    {
        image = '',
        imageCustomClass = '',
        text = 'L5',
        textCustomClass = '',
        size = 'normal',
        topLeftBadge = null,
        onClick,
        className = '',
        shouldHighlight = false,
    }: Props,
    ref: ForwardedRef<HTMLDivElement>,
) {
    const avatarNode = image ? (
        <img
            className={`avatar-img ${imageCustomClass}`}
            src={image}
            alt="avatar"
            draggable={false}
        />
    ) : (
        <div className={`avatar-text text-uppercase ${size} ${textCustomClass}`}>
            {text.substring(0, 3)}
        </div>
    );
    return (
        <div
            ref={ref}
            className={classnames('avatar-wrapper', className, size, {
                'with-topLeftBadge': !!topLeftBadge,
                'avatar-selected': shouldHighlight,
            })}
            onClick={onClick}
        >
            {!!topLeftBadge && <div className="topLeftBadge">{topLeftBadge}</div>}
            {avatarNode}
        </div>
    );
}
const Avatar = React.memo(React.forwardRef(AvatarFunc));
Avatar.displayName = 'Avatar';

export default Avatar;
